import { render, staticRenderFns } from "./ImportPhysicianList.vue?vue&type=template&id=f19f6766&scoped=true&"
import script from "./ImportPhysicianList.vue?vue&type=script&lang=js&"
export * from "./ImportPhysicianList.vue?vue&type=script&lang=js&"
import style0 from "./ImportPhysicianList.vue?vue&type=style&index=0&id=f19f6766&lang=scss&scoped=true&"
import style1 from "./ImportPhysicianList.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f19f6766",
  null
  
)

export default component.exports